import React from 'react';
import { cn } from 'lib/utils';

export type TagProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
};

const Tag = ({
  children,
  className: classNameProp,
  variant = 'primary',
}: TagProps) => {
  const className = cn(
    'inline-flex items-center justify-center text-eyebrow font-mono uppercase px-3 py-2 rounded-lg transition-colors',
    {
      // Primary variant
      'bg-athletic-200/20 text-clay-50': variant === 'primary',
      // Secondary variant
      'bg-neutral-200/20 text-clay-50': variant === 'secondary',
    },
    classNameProp
  );

  return <span className={className}>{children}</span>;
};

export default Tag;
